import { Box } from "@material-ui/core";
import React from "react";
import { Row } from "react-bootstrap";
import { Col, Form } from "react-bootstrap";
import {
  fontStyle,
  fontStyleBlackHeading,
  fontStyleRedEventProfile,
  iconColor,
} from "../../ui/constants";
import DoubleArrowRoundedIcon from "@material-ui/icons/DoubleArrowRounded";
import BlockIcon from "@material-ui/icons/Block";

class FunFees extends React.Component {
  render() {
    const { event } = this.props;
    const licenses = JSON.parse(event?.license || "[]");
    return (
      <Box p={2}>
        <Form>
          <Row>
            {event.isPast ? (
              <Col lg={12} md={12} sm={12} xs={12}>
                  <Box style={fontStyle} bgcolor="#F7F7F7" p={3} border="1px solid #DCDCDC">
                    <span style={{ marginRight: 2 }}>
                      <BlockIcon />
                    </span>
                    Payments are disabled
                  </Box>
            
              </Col>
            ) : (
              <Col lg={12} md={12} sm={12} xs={12}>
                <Form.Group>
                  <Form.Group>
                    <Box style={fontStyleRedEventProfile}>
                      Fun Fees & Requirements
                    </Box>
                  </Form.Group>
                  <Form.Group>
                    
                      <DoubleArrowRoundedIcon style={iconColor} />
                      <span style={fontStyleBlackHeading}>
                        ${(event.driver_price / 100) * event.min_drivers}{" "}
                      </span>
                      <span style={fontStyleRedEventProfile}>(AUD)</span> per
                      team.
                    
                  </Form.Group>
                  <Form.Group>
                   
                      <DoubleArrowRoundedIcon style={iconColor} />
                      Team includes {event.min_drivers} drivers & car entry.
                  
                  </Form.Group>
                  <Form.Group>
                    
                      <DoubleArrowRoundedIcon style={iconColor} />
                      First {event.min_drivers} drivers = $
                      {event.driver_price / 100} (AUD) per driver.
                  
                  </Form.Group>
                  <Form.Group>
                 
                      <DoubleArrowRoundedIcon style={iconColor} />{" "}
                      <span style={iconColor}>
                        ${event.extra_driver_price / 100}
                      </span>{" "}
                      (AUD) for each additional driver over {event.min_drivers}{" "}
                      drivers.
             
                  </Form.Group>
                  <Form.Group>
                
                      <DoubleArrowRoundedIcon style={iconColor} />
                      Crew members ${event.crew_price / 100} (AUD) each.
             
                  </Form.Group>
                  <Form.Group>
                 
                      <DoubleArrowRoundedIcon style={iconColor} />
                      Minimum drivers: {event.min_drivers}
               
                  </Form.Group>
                  <Form.Group>
                 
                      <DoubleArrowRoundedIcon style={iconColor} />
                      Minimum crew: {event.min_crew}
             
                  </Form.Group>

                  {licenses.length>0 && (
                    <Form.Group>
                      <h6>
                        <DoubleArrowRoundedIcon style={iconColor} />
                        License Required
                      </h6>
                      <ul>
                        {licenses?.map((item) => (
                          <li>{item?.licenseType}</li>
                        ))}
                      </ul>
                    </Form.Group>
                  )}
                </Form.Group>
              </Col>
            )}
          </Row>
        </Form>
      </Box>
    );
  }
}

export default FunFees;
